export function sanitizeMoneyDraft(rawValue: string): string {
  let sanitized = "";
  let hasDecimal = false;
  let fractionDigits = 0;

  for (const character of rawValue.replaceAll(",", "")) {
    if (character >= "0" && character <= "9") {
      if (hasDecimal && fractionDigits >= 2) continue;
      sanitized += character;
      if (hasDecimal) fractionDigits += 1;
      continue;
    }
    if (character === "." && !hasDecimal) {
      sanitized += character;
      hasDecimal = true;
    }
  }

  return sanitized;
}

export function moneyDraftToMinor(rawValue: string): number {
  const sanitized = sanitizeMoneyDraft(rawValue);
  const [whole = "", fraction = ""] = sanitized.split(".");
  const major = Number.parseInt(whole || "0", 10);
  const cents = Number.parseInt(fraction.padEnd(2, "0") || "0", 10);
  const minor = major * 100 + cents;
  return Number.isSafeInteger(minor) ? Math.max(0, minor) : 0;
}

export function formatMoneyMinor(valueMinor: number): string {
  const safeMinor =
    Number.isFinite(valueMinor) && valueMinor > 0
      ? Math.round(valueMinor)
      : 0;
  return (safeMinor / 100).toFixed(2);
}
